import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { AlvaMetricsDto } from '../models/alva-metrics.model';
import { InseminationAdviceDto } from '../models/insemination-advice.model';
import { ThresholdParams } from '../models/threshold-params.model';

@Injectable({
  providedIn: 'root',
})
export class InseminationAdviceService {
  private readonly http = inject(HttpClient);

  private readonly env = inject(EnvironmentInjector);
  private readonly baseUrl = `${this.env.APIM_BASE_URL}/herd-v2-service`;

  /**
   * Gets insemination advice for all eligible cows at the current ShipTo location
   */
  public getInseminationAdvice(
    thresholds?: ThresholdParams | null,
  ): Observable<InseminationAdviceDto[]> {
    let params = new HttpParams();

    if (thresholds) {
      params = params
        .set('minAgeWithoutMeasurement', thresholds.minAgeWithoutMeasurement.toString())
        .set('minAgeWithMeasurement', thresholds.minAgeWithMeasurement.toString())
        .set('minimumHeightWithMeasurement', thresholds.minimumHeightWithMeasurement.toString());
    }

    return this.http.get<InseminationAdviceDto[]>(`${this.baseUrl}/cows/insemination-advice`, {
      params: thresholds ? params : undefined,
    });
  }

  /**
   * Gets Alva metrics for insemination advice at the current ShipTo location
   */
  public getAlvaMetrics(minimumHeightWithMeasurement?: number): Observable<AlvaMetricsDto> {
    let params = new HttpParams();
    if (minimumHeightWithMeasurement != null) {
      params = params.set('minimumHeightWithMeasurement', minimumHeightWithMeasurement.toString());
    }
    return this.http.get<AlvaMetricsDto>(`${this.baseUrl}/cows/insemination-advice/alva`, {
      params: minimumHeightWithMeasurement == null ? undefined : params,
    });
  }
}
